export class GdprConstants {
    public static readonly TERMS_OF_SERVICE_PAGE_LINK = "_gdpr/route/tos";
    public static readonly PRIVACY_POLICY_PAGE_LINK = "_gdpr/route/privacy-policy";
}